// components/create/PrivacySelector.js
import React from 'react';
import '../../styles/PrivacySelector.scss';
import Icon from '../Icon';
import Portal from '../Portal';

const PRIVACY_OPTIONS = [
  {
    value: 'public',
    icon: 'globe-outline',
    label: 'Public',
    description: 'Anyone can see and RSVP to your event',
  },
  {
    value: 'private',
    icon: 'lock-closed-outline',
    label: 'Private',
    description: 'Only people you invite can see the event',
  },
  {
    value: 'approval',
    icon: 'checkmark-circle-outline',
    label: 'Request Approval',
    description: 'Guests must request to attend, you approve',
  },
];

export default function PrivacySelector({ visible, onClose, selectedPrivacy, onSelect }) {
  if (!visible) return null;

  return (
    <Portal>
    <div className="modal-overlay" onClick={onClose}>
      <div className="privacy-selector-modal" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header">
          <button className="close-button" onClick={onClose}>
            <Icon name="close" />
          </button>
          <h2 className="modal-title">Privacy Settings</h2>
          <div className="header-spacer"></div>
        </div>

        {/* Content */}
        <div className="modal-content">
          {PRIVACY_OPTIONS.map((option) => (
            <div
              key={option.value}
              className={`privacy-option ${selectedPrivacy === option.value ? 'selected' : ''}`}
              onClick={() => onSelect(option.value)}
            >
              <div className="option-content">
                <div className="option-icon">
                  <Icon name={option.icon} />
                </div>
                <div className="option-text">
                  <h3 className="option-label">{option.label}</h3>
                  <p className="option-description">{option.description}</p>
                </div>
                {selectedPrivacy === option.value && (
                  <div className="option-checkmark">
                    <Icon name="checkmark-circle" />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
    </Portal>
  );
}